import { SessionUser } from './types';

const SESSION_USER_KEY = 'rentegic:session-user';

export function persistSessionUser(user: SessionUser | null): void {
  if (user) {
    sessionStorage.setItem(SESSION_USER_KEY, JSON.stringify(user));
  } else {
    sessionStorage.removeItem(SESSION_USER_KEY);
  }
}

export function readSessionUser(): SessionUser | null {
  try {
    const raw = sessionStorage.getItem(SESSION_USER_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as SessionUser;
  } catch {
    return null;
  }
}
